import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  MdLogin,
  MdOutlineAccountBalanceWallet,
  MdOutlineSupervisorAccount,
  MdMenu,
  MdClose,
  MdCardMembership,
  MdOutlinePointOfSale,
  MdDeleteOutline,
  MdQrCode2,
  MdPayment,
  MdHistory,
} from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { CiSettings } from "react-icons/ci";
import avatarImg from "../../images/shapes/Profile_Logo 1.png";
import LogoutModal from "../RetailerBusinessAgent/LogoutModal";
import AccountClosureModal from "../AccountClosureModal/AccountClosureModal";
import "../RetailerBusinessAgent/SideBar.css";

function SideBar({ user }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showClosureModal, setShowClosureModal] = useState(false);

  const handleNavClick = () => {
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  return (
    <>
      <aside className={`sidebar_container1 ${mobileOpen ? "expanded" : ""}`}>
        {/* Profile Header */}
        <div className="profile1">
          <img
            src={user?.avatar || avatarImg}
            alt="Profile"
            className="profile-img1"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = avatarImg;
            }}
          />

          <div className="profile-info1">
            <h3 className="profile-name1">{user?.fullName || "User"}</h3>
            <p className="profile-role1">Trading As {user?.retailName}</p>
          </div>

          <button
            className="sidebar-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <MdClose /> : <MdMenu />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-content">
          <ul className="menu1">
            <li>
              <NavLink
                to="/retail-business/wallet"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdOutlineAccountBalanceWallet className="icon1" />
                Wallets
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/retail-business/topcoin-purchase"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdPayment className="icon1" />
                Buy TopCoin
              </NavLink>
            </li>

            {/* <li>
              <NavLink
                to="/retail-business/topcoin-purchase/history"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdHistory className="icon1" />
                Purchase History
              </NavLink>
            </li> */}

            {/* <li>
              <NavLink to="/retail-business/card-collection" className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}>
                <MdCardMembership className="icon1" />
                Premium Card Collection
              </NavLink>
            </li> */}

             <li>
              <NavLink
                to="/retail-business/transaction-window"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdOutlinePointOfSale className="icon1" />
                Transaction
              </NavLink>
            </li> 

           <li>
              <NavLink
                to="/retail-business/retail-tc-distribution"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdQrCode2 className="icon1" />
                Retail TC Distribution
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/retail-business/edit-profile"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <CgProfile className="icon1" />
                Edit Profile
              </NavLink>
            </li>
          </ul>

          <div className="bottom-menu1">
            <hr />
            {/* <button
              className="logout-btn1"
              onClick={(e) => {
                e.preventDefault();
                alert("Settings page coming soon!");
              }}
            >
              <CiSettings className="icon1" /> Settings
            </button> */}
            {/* <button
              className="logout-btn1 gap-1"
              style={{ color: "#dc2626", marginBottom: "8px" }}
              onClick={() => setShowClosureModal(true)}
            >
              <MdDeleteOutline className="icon1" style={{ color: "#dc2626" }} /> Forgot Me – Close My Account
            </button> */}
            <button
              className="logout-btn1"
              onClick={() => setShowLogoutModal(true)}
            >
              <MdLogin className="icon1" /> Logout
            </button>
          </div>
        </nav>
      </aside>

      {showLogoutModal && (
        <LogoutModal user={user} onClose={() => setShowLogoutModal(false)} />
      )}

      {showClosureModal && (
        <AccountClosureModal
          isOpen={showClosureModal}
          onClose={() => setShowClosureModal(false)}
        />
      )}
    </>
  );
}

export default React.memo(SideBar);
